
import { useCall } from "../../hooks/use-call.js";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs.js";
import { ProjectConsents } from "./project-consents.js";
import { ProjectEmailTemplates } from "./project-email-templates.js";
import { ProjectNotices } from "./project-notices.js";
import { ProjectSettings } from "./project-settings.js";
import { ProjectTenants } from "./project-tenants.js";

export interface ProjectDetailTabsProps {
  projectId: string;
  canManage?: boolean;
  canDelete?: boolean;
  onDeleted?: () => void;
  onSelectTenant?: (id: string) => void;
}

export const ProjectDetailTabs = ({
  projectId,
  canManage = false,
  canDelete = false,
  onDeleted,
  onSelectTenant,
}: ProjectDetailTabsProps) => {
  // The email tab opens on the product's default locale.
  const { data } = useCall("getProject", { projectId });

  return (
    <Tabs defaultValue="tenants">
      <TabsList>
        <TabsTrigger value="tenants">Tenants</TabsTrigger>
        <TabsTrigger value="emails">Emails</TabsTrigger>
        <TabsTrigger value="consents">Consents</TabsTrigger>
        <TabsTrigger value="notices">Notices</TabsTrigger>
        <TabsTrigger value="settings">Settings</TabsTrigger>
      </TabsList>
      <TabsContent value="tenants" className="mt-4">
        <ProjectTenants projectId={projectId} onSelectTenant={onSelectTenant} />
      </TabsContent>
      <TabsContent value="emails" className="mt-4">
        <ProjectEmailTemplates
          projectId={projectId}
          defaultLocale={data?.defaultLocale ?? "en"}
          canManage={canManage}
        />
      </TabsContent>
      <TabsContent value="consents" className="mt-4">
        <ProjectConsents projectId={projectId} canManage={canManage} />
      </TabsContent>
      <TabsContent value="notices" className="mt-4">
        <ProjectNotices projectId={projectId} canManage={canManage} />
      </TabsContent>
      <TabsContent value="settings" className="mt-4">
        <ProjectSettings
          projectId={projectId}
          canManage={canManage}
          canDelete={canDelete}
          onDeleted={onDeleted}
        />
      </TabsContent>
    </Tabs>
  );
};
